import { useMediaQuery, useTheme } from '@mui/material';

// Single source of truth for the "mobile" breakpoint across management pages.
// Mobile is < sm (600px) where we switch tables to a stacked card list.
export default function useIsMobile() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
}
